// Design tokens — color palette for Sunbird Serve
// Aligned with serve.evidyaloka.org — deep navy, teal accents, warm highlights
export const palette = {
  primary: {
    main: '#0E7490', // Teal — primary actions, links, active states
    light: '#22D3EE',
    dark: '#0C4A6E',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#F59E0B', // Warm amber — CTAs, highlights
    light: '#FCD34D',
    dark: '#D97706',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#059669',
    light: '#34D399',
    dark: '#065F46',
  },
  warning: {
    main: '#D97706',
    light: '#FBBF24',
    dark: '#92400E',
  },
  error: {
    main: '#DC2626',
    light: '#F87171',
    dark: '#991B1B',
  },
  info: {
    main: '#0284C7',
    light: '#38BDF8',
    dark: '#075985',
  },
  background: {
    default: '#F8FAFC',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#0F172A', // Deep navy for text
    secondary: '#475569',
    disabled: '#94A3B8',
  },
  divider: '#E2E8F0',
};
